import type { LobbyPlayerType } from "./LobbyPlayerType.js";
import type { GamePlayerData } from "../api/game/GamePlayerData.js";
import type { PlayerType } from "../../royalur/model/PlayerType.js";
import type { APIPublicGamePreferences, APIUser } from "../api/api_schema.js";
import { defaultGamePreferences } from "../api/api_schema.js";
import type { BotType } from "../game/BotType.js";


export abstract class LobbyPlayer {
    private readonly type: LobbyPlayerType;
    private readonly gameData: GamePlayerData | null;

    protected constructor(type: LobbyPlayerType, gameData: GamePlayerData | null) {
        this.type = type;
        this.gameData = gameData;
    }

    getType(): LobbyPlayerType {
        return this.type;
    }

    getGameData(): GamePlayerData | null {
        return this.gameData;
    }

    getPlayerType(): PlayerType | null {
        if (this.gameData === null)
            return null;
        return this.gameData.getPlayerType();
    }

    abstract getBotTypeOrNull(): BotType | null;

    abstract getUserOrNull(): APIUser | null;

    abstract isAnonymous(): boolean;

    getPreferences(): APIPublicGamePreferences | null {
        return defaultGamePreferences;
    }

    abstract getShortName(): string;

    getLongName(): string {
        return this.getShortName();
    }

    abstract withPreferences(preferences: APIPublicGamePreferences): LobbyPlayer;

    abstract withGameData(gameData: GamePlayerData): LobbyPlayer;

    abstract equals(other: LobbyPlayer): boolean;

    static _baseEquals(player1: LobbyPlayer, player2: LobbyPlayer): boolean {
        if (player1.type !== player2.type)
            return false;
        if (player1.gameData === null)
            return player2.gameData === null;

        return player1.gameData.equals(player2.gameData);
    }
}
